import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { locations } from '../data/mock';

// Fix for default marker icons in Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
});

const LocationMap = () => {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);

  useEffect(() => {
    if (!mapRef.current || mapInstanceRef.current) return;

    // Initialize map centered on Bora Bora
    const map = L.map(mapRef.current).setView([-16.5004, -151.7506], 12);

    // Add OpenStreetMap tiles
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors'
    }).addTo(map);

    // Custom icons
    const freeIcon = L.divIcon({
      className: 'custom-marker',
      html: `<div style="background-color: #10b981; width: 35px; height: 35px; border-radius: 50%; border: 4px solid white; box-shadow: 0 3px 10px rgba(0,0,0,0.4); display: flex; align-items: center; justify-center;">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>
      </div>`,
      iconSize: [35, 35],
      iconAnchor: [17.5, 17.5]
    });

    const deliveryIcon = L.divIcon({
      className: 'custom-marker',
      html: `<div style="background-color: #0077FF; width: 35px; height: 35px; border-radius: 50%; border: 4px solid white; box-shadow: 0 3px 10px rgba(0,0,0,0.4); display: flex; align-items: center; justify-center;">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>
      </div>`,
      iconSize: [35, 35],
      iconAnchor: [17.5, 17.5]
    });

    // Add markers for each location
    locations.forEach((location) => {
      const icon = location.isFree ? freeIcon : deliveryIcon;
      const marker = L.marker(location.coordinates, { icon }).addTo(map);
      const deliveryText = location.isFree ? '<span style="color: #10b981; font-weight: bold;">✓ Retrait gratuit</span>' : '<span style="color: #FF8C00; font-weight: bold;">🚚 Livraison payante</span>';
      marker.bindPopup(`
        <div style="text-align: center; padding: 10px; min-width: 180px;">
          <strong style="font-size: 18px; color: #0077FF;">${location.name}</strong><br/>
          <span style="font-size: 14px; color: #666; margin: 5px 0; display: block;">${location.address}</span>
          <div style="margin-top: 8px;">${deliveryText}</div>
        </div>
      `);
    });

    mapInstanceRef.current = map;

    // Cleanup
    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
      }
    };
  }, []);

  return (
    <div 
      ref={mapRef} 
      className="w-full h-96 z-0"
      style={{ minHeight: '384px' }}
    />
  );
};

export default LocationMap;
